import React from "react";
const steps = [{
  title: "Briefing e Alinhamento",
  description: "Entendemos seus objetivos e definimos a estratégia ideal para seu projeto."
}, {
  title: "Produção e Captação",
  description: "Execução profissional com equipamentos de ponta em nosso estúdio ou locação."
}, {
  title: "Edição e Finalização",
  description: "Pós-produção detalhada para garantir máxima qualidade visual e sonora."
}, {
  title: "Entrega e Performance",
  description: "Disponibilização dos materiais e suporte na implementação estratégica."
}];
export default function Processo() {
  return <section id="processo" className="bg-background py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16 text-center md:text-left">
          <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground">
            Como funcionam nossos serviços
          </h2>
          <p className="mt-4 text-muted-foreground max-w-2xl text-lg">
            Um roteiro claro e estruturado para transformar desafios em resultados escaláveis.
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-0">
          {steps.map((step, i) => <div key={i} data-index={i} className="relative flex-1 group">
              {}
              {i !== steps.length - 1 && <div className="hidden md:block absolute top-3 left-[50%] w-full h-[1px] bg-border z-0" />}
              
              {}
              {i !== steps.length - 1 && <div className="md:hidden absolute left-3 top-6 bottom-0 w-[1px] bg-border z-0" />}

              <div className="flex flex-row md:flex-col items-start md:items-center gap-4 md:gap-6 relative z-10">
                {}
                <div className="w-6 h-6 rounded-full border-2 border-primary bg-background shrink-0 flex items-center justify-center transition-colors duration-300 group-hover:bg-primary/5" />

                {}
                <div className="text-left md:text-center pb-12 md:pb-0 pr-4 md:pr-0 md:px-2">
                  <h3 className="font-default font-bold text-foreground text-base">
                    {step.title}
                  </h3>
                  <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}